angular.module('impactx.system').controller('EditGlobalLobbyCtrl', [
    '$scope',
    'dataGen',
    'ToolbarService',
    '$mdDialog',
    'ToastService',
    'TranslationService',
    EditGlobalLobbyCtrl]);

function EditGlobalLobbyCtrl($scope, dataGen, ToolbarService, $mdDialog, ToastService, TranslationService) {
    var self = this;

    dataGen.getData($scope, {}, '/systemadministration/editlobby/view').then(function () {
        defineButtons();
        $scope.labelMoveUp = TranslationService.get("moveUp");
        $scope.labelMoveDown = TranslationService.get("moveDown");
    });

    self.save = function () {
        return dataGen.postAsForm({}, {data: $scope.data}, "/systemadministration/editlobby/save").then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };

    self.lobbySettingDown = function (settings, index) {
        if (index < settings.length - 1) {
            var toMoveItem = settings[index];
            settings[index] = settings[index + 1];
            settings[index + 1] = toMoveItem;
        }
    };

    self.lobbySettingUp = function (settings, index) {
        if (index > 0) {
            var toMoveItem = settings[index];
            settings[index] = settings[index - 1];
            settings[index - 1] = toMoveItem;
        }
    };

   function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'dialogaction'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}